export default __webpack_public_path__ + "static/logo-6fe92555c423fbcd01a83e209fd66c9b.png";